export const Geocode = {
    getCurrentPosition: (cb, options) => {},
    watchPosition: (cb, options) => { return -1; },
    clearWatch: id => {},
};
